import React from 'react';
import LazyImage from './LazyImage';
import '../styles/Footer.css';

const Footer = () => {
  const instagramImages = [
    require('../assets/images/DSC1303.jpg'),
    require('../assets/images/DSC1299.jpg'),
    require('../assets/images/DSC1297.jpg'),
    require('../assets/images/DSC5581.jpg')
  ];

  return (
    <footer className="footer">
       <div className="footer-top-line"></div>
       
       <div className="container footer-content">
           <div className="footer-grid">
               {/* Logo */}
               <div className="footer-logo-section">
                   <h2 className="footer-logo">
                        H<span className="text-brand">O</span>RAZEL
                   </h2>
                   <p className="footer-desc">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque con Lorem ipsum dolor sit amet, cons adipisc.
                   </p>
               </div>

               {/* Instagram Gallery */}
               <div className="footer-gallery-section">
                   <h3 className="footer-heading">INSTA GALLERY</h3>
                   <div className="insta-grid">
                       {instagramImages.map((img, i) => (
                           <a href="/" key={i} className="insta-item">
                                <LazyImage src={img} alt={`Instagram ${i + 1}`} />
                                <div className="insta-overlay"></div>
                           </a>
                       ))}
                   </div>
               </div>

               {/* Contact */}
               <div className="footer-contact-section">
                   <h3 className="footer-heading">CONTACT</h3>
                   <div className="contact-list">
                       <p className="contact-item">Phone : <span>+91 9812 3456 6789</span></p>
                       <p className="contact-item">Email : <span>company@website.com</span></p>
                       <div className="social-links">
                           <a href="/" className="social-icon" aria-label="Instagram">●</a>
                           <a href="/" className="social-icon" aria-label="Facebook">●</a>
                           <a href="/" className="social-icon" aria-label="Twitter">●</a>
                       </div>
                   </div>
               </div>
           </div>
           
           <div className="footer-copyright">
               Copyright © 2023 HorazelMedia. All Rights Reserved.
           </div>
       </div>
    </footer>
  );
};

export default Footer;
